import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {Alert} from 'Components/Partials';
import {Input, Textarea, FormHandler} from 'Components/Form';

import BookingApi from 'Services/Api/Exhibitor/Booking';
import {translation} from 'Services/TranslationHelpers';
import DarkButton from "Components/Button/DarkButton";

class Book extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = translation('exhibitors', 'successful_booking');

    /**
     * @method request
     * @param {object} form
     * @return {*}
     */
    request = (form) => {
        return BookingApi.post(null, {
            ...form,
            exhibitor_booking_item_id: this.props.item_id
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {form, handleSubmit, handleInput, getFieldError, alert, working} = this.props;

        return (
            <Modal className={"bg-app-light-green text-white"}>
                <ModalHeader onClose={this.props.onClose} className="border-none text-white" titleClassName="text-white">
                    {translation('exhibitors', 'submit_your_booking')}
                </ModalHeader>

                <form onSubmit={e => handleSubmit(e, this.request, this.success, true)}>
                    <ModalBody className="border-0">
                        {alert && (<Alert {...alert} />)}

                        <Input
                            containerClassName="mb-4 text-app-blue"
                            label={translation('auth_frontend', 'name')}
                            value={form.name ?? ''}
                            error={getFieldError('name')}
                            onChange={v => handleInput('name', v)}
                        />

                        <Input
                            containerClassName="mb-4 text-app-blue"
                            label={translation('auth_frontend', 'email')}
                            value={form.email ?? ''}
                            error={getFieldError('email')}
                            onChange={v => handleInput('email', v)}
                        />

                        <Textarea
                            containerClassName="mb-4 text-app-blue"
                            label={translation('exhibitors', 'message')}
                            value={form.message ?? ''}
                            error={getFieldError('message')}
                            onChange={v => handleInput('message', v)}
                        />
                    </ModalBody>

                    <ModalFooter alignment="center" className="bg-transparent">
                        <DarkButton
                            text={translation('misc', 'close')}
                            onClick={this.props.onClose}
                            className="mr-2"
                        />
                        <DarkButton
                            className="ml-2"
                            text={translation('misc', 'submit')}
                            disabled={working}
                            working={working}
                        />
                    </ModalFooter>
                </form>
            </Modal>
        );
    }
}
export default FormHandler(Book);
